// extracted by mini-css-extract-plugin
export default {"title":"styles_title__nf7vo","button-wrapper":"styles_button-wrapper__jVQa7","root":"styles_root__64ogo"};